exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reset-password-view>.login__form {\n  height: 47rem;\n}\n\n", ""]);

// exports
